import { IconArrowRight } from 'central-icons/IconArrowRight';
import classNames from 'classnames';

import { Text } from '@revelio/ui';

import modalStyles from '../../DataBuilder/data-builder-modals.module.css';
import styles from './confirmation-mapped-columns.module.css';
import type { DataInterface } from './file-upload.types';

const ConfirmationMappedColumns = ({
  mappedColumns,
}: {
  mappedColumns: DataInterface['mappedColumns'];
}) => (
  <div className={styles.mappedColumns}>
    <Text
      as="h2"
      className={modalStyles.modalInkText}
      fontSize="md"
      weight="semibold"
    >
      Mapped Columns
    </Text>
    <ul className={styles.columnList}>
      {mappedColumns?.map((item, index) => {
        // @ts-expect-error noUncheckedIndexedAccess
        const itemKey: string = Object.keys(item)[0];
        const itemValue = item[itemKey as keyof typeof item];
        return (
          <li
            key={`${itemValue}-${index}`}
            className={`${modalStyles.modalInkText} ${styles.columnRow}`}
          >
            {itemKey}{' '}
            <IconArrowRight
              size="1em"
              className={classNames(modalStyles.modalInkText, styles.arrowIcon)}
            />{' '}
            {itemValue}
          </li>
        );
      })}
    </ul>
  </div>
);

export default ConfirmationMappedColumns;
